var y = Object.defineProperty;
var l = (n, o, t) => o in n ? y(n, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[o] = t;
var s = (n, o, t) => l(n, typeof o != "symbol" ? o + "" : o, t);
import { useOfferStore as R } from "../../../store/index.mjs";
import { loadScriptAsync as z } from "../../../utils/load-script.mjs";
import { RAZORPAY_SCRIPT as u } from "../constants/index.mjs";
import { toast as w } from "@systemeio/ui";
import { useState as d, useEffect as I } from "react";
import { useDesignContext as g } from "../../../providers/use-design-provider.mjs";
class S {
  constructor(o) {
    s(this, "options");
    s(this, "razorpayInstance");
    this.options = o, typeof window < "u" && "Razorpay" in window && (this.razorpayInstance = new window.Razorpay(this.options));
  }
  on(o, t) {
    this.razorpayInstance.on(o, t);
  }
  open() {
    this.razorpayInstance.open();
  }
}
function x() {
  const [n, o] = d(!1), [t, p] = d(!1), { currency: i, pricePlan: a, finalAmount: f } = R(), {
    state: { primaryColor: c }
  } = g(), m = function(r) {
    const e = {
      key: r.keyId,
      amount: f,
      currency: i == null ? void 0 : i.toUpperCase(),
      name: r.vendorName,
      description: a == null ? void 0 : a.name,
      prefill: {
        name: r.prefill.name,
        email: r.prefill.email,
        contact: r.prefill.phone
      },
      theme: {
        color: c
      },
      handler: async () => {
        window.location.assign(r.redirectUrl);
      }
    };
    if (r.rpOrderId)
      e.order_id = r.rpOrderId;
    else if (r.rpSubscriptionId)
      e.subscription_id = r.rpSubscriptionId;
    else
      throw Error("RP order id and subscription id is missing");
    return e;
  };
  return I(() => {
    const r = async () => {
      try {
        o(!0), await z(u, document), p(!0);
      } catch (e) {
        w.error(e.message);
      } finally {
        o(!1);
      }
    };
    "Razorpay" in window ? p(!0) : r();
  }, []), { Razorpay: S, generateOptions: m, isRazorpayReady: t, isRazorpayFetching: n };
}
export {
  x as default
};
